export default __webpack_public_path__ + "static/char-s-36-ko-ff9a4b2bff736f033d5fba878c87dd83.png";